import React from 'react'
import { sh, compose, ReduxWrapper } from 'common-data/datahelpers'
import { componentGetCompareProps } from 'common-tools/index'
import Calendar from '@toast-ui/react-calendar'
import _ from 'common-tools/LodashHelper'
class CalendarViewBoxPlain extends React.Component {
  constructor (props) {
    super(props)
  }

  calendarRef = this.props.calendarRef

  componentDidMount () {
    var cal = this.calendarRef.current.calendarInstance || {}
    cal.today()
  }

  componentDidUpdate (prevProps, prevState) {
    let activeView = componentGetCompareProps('activeView', this.props, prevProps, {})

    if (activeView.Current.view !== activeView.Previous.view) {
      this.calendarRef.current.calendar.changeView(activeView.Current.view, activeView.Current.date)
    } else if (activeView.Current.date !== activeView.Previous.date) {
      this.calendarRef.current.calendar.changeView(activeView.Current.view, activeView.Current.date)
    }
  }

  onDatesSet (selectInfo) {
    const { onDatesSet } = this.props
    if (_.isFunction(onDatesSet) === false) {
      return
    }
    onDatesSet(selectInfo)
  }

   onAfterRenderEvent = (event) => {
     console.log(event.title)
   };
   render () {
     const { events, selectable, height, visibleWeeksCount, template } = this.props

     return (
       <Calendar
         key='cal'
         height={height}
         view="month"
         month={{
           dayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
           visibleWeeksCount: visibleWeeksCount
         }}
         events={events}
         onAfterRenderEvent={this.onAfterRenderEvent}
         template={template}
         gridSelection={false}
         usageStatistics={false}
         useDetailPopup={true}// Whether to use the built-in event details pop-up
         useFormPopup={true}// Whether to use the built-in event creation/modification pop-up
         isReadOnly={selectable}
         timezone={ { zones: [] }}
         setDate={this.onDatesSet.bind(this)}
         ref={this.calendarRef}
       />

     )
   }
}

export const CalendarViewBox = compose(
  ReduxWrapper([
    sh.SessionAccount
  ])
)(CalendarViewBoxPlain)

export default CalendarViewBox
